import { render, staticRenderFns } from "./ClasificacionPatenteTable.vue?vue&type=template&id=8d8c9cfc&scoped=true&"
import script from "./ClasificacionPatenteTable.vue?vue&type=script&lang=js&"
export * from "./ClasificacionPatenteTable.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionPatenteTable.vue?vue&type=style&index=0&id=8d8c9cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8c9cfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8d8c9cfc', component.options)
    } else {
      api.reload('8d8c9cfc', component.options)
    }
    module.hot.accept("./ClasificacionPatenteTable.vue?vue&type=template&id=8d8c9cfc&scoped=true&", function () {
      api.rerender('8d8c9cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ClasificacionPatentes/ClasificacionPatenteTable.vue"
export default component.exports